import { useTranslation } from 'react-i18next';
import ChatBubble from '../../../components/Chat/Chat';
import AskMascot from '../../../assets/kitoBuddy/Kito-Asking-What-Is 1.png';

export default function WhatSection({ answer, question }) {
  const { t } = useTranslation();
  const answerItems = Array.isArray(answer) ? answer : [answer];

  return (
    <div>
      <ChatBubble img={AskMascot} text={t(question)} />
      <div className="what__content">
        {answerItems.filter(Boolean).map((answerText, index) => (
          <p key={answerText || index}>{t(answerText)}</p>
        ))}
      </div>
    </div>
  );
}
